import React from "react";
import { SvgIcon } from "@mui/material";
import { cleanIconProps } from "./cleanIconProps";

const MinusCircleIcon = (props) => {
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
      {...cleanIconProps(props)}
    >
      <circle
        style={{ ...props.circleStyle }}
        className="minus-circle-1"
        cx="152.87772"
        cy="153.41826"
        r="106.83776"
      />
      <path
        className="minus-circle-2"
        d="M99.57823,138.94555h106.599a14.47264,14.47264,0,0,1,14.47271,14.47271h0A14.47264,14.47264,0,0,1,206.17722,167.891H99.57823a14.47264,14.47264,0,0,1-14.47271-14.47271h0A14.47264,14.47264,0,0,1,99.57823,138.94555Z"
      />
    </SvgIcon>
  );
};

export default MinusCircleIcon;
